"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _stationSetting = require("@/assets/js/stationSetting");

var _vuex = require("vuex");

var _vueEcharts = _interopRequireDefault(require("vue-echarts"));

var echarts = _interopRequireWildcard(require("echarts"));

var _formatDate = require("@/assets/js/formatDate");

var _i18n = require("@/assets/js/i18n");

var _digital = require("@/assets/js/digital");

var _keymap = require("@/assets/js/keymap.js");

var _message = require("@/components/dialog/message");

var _vue2Countdown = _interopRequireDefault(require("@choujiaojiao/vue2-countdown"));

var _finance = require("@/model/finance/finance");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  dialogVisible: true,
  components: {
    Countdown: _vue2Countdown.default,
    "v-chart": _vueEcharts.default
  },
  props: {
    productId: {
      type: [String, Number],
      default: ""
    }
  },
  data: function data() {
    var _this = this;

    return {
      showName: "",
      headerText: "汇信池规则",
      showData: "",
      rateTypeMaps: _keymap.rateTypeMaps,
      quantTagMaps: _keymap.quantTagMaps,
      financialStatusMaps: _keymap.financialStatusMaps,
      financialStatusMapsTwo: _keymap.financialStatusMapsTwo,
      icoTitle: "汇信池：早一步发现价值，寻找下一个比特币",
      pageLoading: true,
      stepActive: 1,
      rate: 1,
      rate1: 1,
      rate2: 1,
      currTab: 1,
      tabList: [{
        value: "1",
        label: "7日年化"
      }, {
        value: "2",
        label: "30日年化"
      }, {
        value: "3",
        label: "历史净值"
      }],
      pieData: [{
        value: 70,
        name: this.translateTitle("项目运作人")
      }, {
        value: 30,
        name: this.translateTitle("份额持有人")
      }],
      options: {
        color: ["#3a7dff", "#f04a5a"],
        tooltip: {
          show: false
        },
        series: [{
          name: "利润分配",
          smooth: true,
          type: "pie",
          radius: ["30%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "12"
            }
          },
          labelLine: {
            show: false
          },
          data: [{
            value: 30,
            name: this.translateTitle("份额持有人")
          }, {
            value: 70,
            name: this.translateTitle("项目运作人")
          }]
        }]
      },
      mutiKlineOptionHistory: {
        color: ["#f04a5a"],
        tooltip: {
          trigger: "axis",
          triggerOn: "mousemove|click",
          formatter: function formatter(val) {
            var result = "";
            _this.showName = val[0].name;
            _this.showData = val[0].data;
            result = "\n          ".concat(val[0].name, "<br />\n          ").concat(val[0].data);
            return result;
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          boundaryGap: false,
          data: []
        }],
        yAxis: [{
          type: "value",
          axisLabel: {
            formatter: function formatter(val) {
              return val.toFixed(3);
            }
          }
        }],
        series: [{
          name: "",
          type: "line",
          smooth: true,
          stack: "总量",
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "rgba(255, 74, 120,1)"
            }, {
              offset: 1,
              color: "rgba(255, 134, 165, 0.09)"
            }])
          },
          fillOpacity: 0.1,
          emphasis: {
            focus: "series"
          },
          data: []
        }]
      },
      mutiKlineOption: {
        color: ["#f04a5a"],
        tooltip: {
          trigger: "axis",
          triggerOn: "mousemove|click",
          formatter: function formatter(val) {
            var result = "";

            if (_this.currTab == 3) {
              _this.showName = val[0].name;
              _this.showData = val[0].data;
              result = "\n          ".concat(val[0].name, "<br />\n          ").concat(val[0].data);
              return result;
            } else {
              _this.showName = val[0].name;
              _this.showData = val[0].data * 100;
              result = "\n          ".concat(val[0].name, "<br />\n          ").concat((val[0].data * 100).toFixed(2), "%");
              return result;
            } //   this.showName = val[0].name;
            //   this.showData = val[0].data * 100;
            //   const result = `
            // ${val[0].name}<br />
            // ${val[0].data * 100}%


            return result;
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "20%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          boundaryGap: false,
          data: []
        }],
        yAxis: [{
          type: "value",
          axisLabel: {
            formatter: function formatter(val) {
              if (_this.currTab == 3) {
                return val.toFixed(3);
              } else {
                return (val * 100).toFixed(0) + "%";
              }
            }
          }
        }],
        series: [{
          name: "",
          type: "line",
          smooth: true,
          stack: "总量",
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "rgba(255, 74, 120,1)"
            }, {
              offset: 1,
              color: "rgba(255, 134, 165, 0.09)"
            }])
          },
          fillOpacity: 0.1,
          emphasis: {
            focus: "series"
          },
          data: []
        }]
      },
      incRateList: [],
      rateList: [],
      rateList30: [],
      klineXList: [],
      klineYList: [],
      currentKlineOption: {
        color: ["#f04a5a"],
        tooltip: {
          trigger: "axis",
          triggerOn: "mousemove|click",
          formatter: function formatter(val) {
            _this.showName = val[0].name;
            _this.showData = (val[0].data * 100).toFixed(2);
            var result = "\n          ".concat(val[0].name, "<br />\n          ").concat((val[0].data * 100).toFixed(2), "%\n        ");
            return result;
          }
        },
        grid: {
          left: "0%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          boundaryGap: false,
          data: this.klineXList
        }],
        yAxis: [{
          type: "value",
          axisLabel: {
            formatter: function formatter(val) {
              return (val * 100).toFixed(2) + "%";
            }
          }
        }],
        series: [{
          name: "",
          type: "line",
          smooth: true,
          stack: "总量",
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "rgba(255, 74, 120,1)"
            }, {
              offset: 1,
              color: "rgba(255, 134, 165, 0.09)"
            }])
          },
          fillOpacity: 0.1,
          emphasis: {
            focus: "series"
          },
          data: this.klineYList
        }]
      },
      productInfo: {
        product_id: 33,
        product_name: "--",
        item_id: 10007,
        channel_id: 101,
        item_type: 1,
        to_item_id: 10069,
        to_item_id_price: "--",
        product_type: 3,
        rate_type: 0,
        quant_tag: 0,
        annual_rate: "--",
        min_fluctuation_annual_rate: "0.0000",
        max_fluctuation_annual_rate: "0.0000",
        day_rate: 0,
        current_rate: "0.0000",
        period: 1,
        start_time: 1620370800,
        stop_time: 1620975600,
        lock_period: 7,
        amount: 0,
        lowest_amount: 0,
        total_amount: "--",
        min_amount: "--",
        max_amount: "--",
        per_min_num: 1,
        per_max_num: 200,
        number_precision: 2,
        price_precision: 2,
        amount_precision: 2,
        trader_profit: 0,
        status: 7,
        union_product_id: 0,
        union_order_by: 1,
        is_union_master: 0,
        public_raise_amount: "--",
        ico_buy_condition: 1,
        ico_user_register_time: 0,
        is_hide: 0,
        is_show_list: 1,
        is_recommand: 1,
        is_delete: 0,
        access_type: 1,
        order_by: 1,
        i18n_lang: "static_finances_product_product_name_330",
        create_time: 1620324487,
        update_time: 1620975363,
        detail: {
          product_id: 33,
          product_intro: "",
          inout_rule: "",
          earnings_rule: "",
          product_code: "--",
          strategy: "",
          ico_url: "https://top6688.zendesk.com/hc/zh-cn/articles/4402147339921-%E8%AE%A4%E8%AF%86-O3",
          ico_eg: "",
          buy_rule: "--",
          risk_tip: "--",
          join_rule: "",
          i18n_lang: "ico_url_31,ico_eg_33,buy_rule_31,risk_tip_31,join_rule_0,product_code_33"
        },
        item_name: "USDT",
        item_url: require("../../../../assets/img/holder-coin-ico.png"),
        to_item_url: require("../../../../assets/img/holder-coin-ico.png"),
        to_item_name: "O3",
        end_time: 1621580400,
        user_profit: 1,
        show_profit: 0
      }
    };
  },
  created: function created() {
    if (_stationSetting.VUE_APP_ID == "AwyOTFRlsfQ5mRkqwCNaEd5T" || _stationSetting.VUE_APP_ID == "DwyOTFRlsfQ5mRkqwCNaEd5T" || _stationSetting.VUE_APP_ID == "J8tstegyx2UjYzJ6J1vNuD3w") {
      this.headerText = "汇信池规则";
      this.icoTitle = "汇信池：早一步发现价值，寻找下一个比特币";
    } else {
      this.headerText = "Launchpad规则";
      this.icoTitle = "打新：早一步发现价值，寻找下一个比特币";
    }

    this.getFinancesProductInfo();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language"
  })),
  methods: {
    routeSplicing: _routeSplicing.default,
    timestampToDate: _formatDate.timestampToDate,
    timestampToDay: _formatDate.timestampToDay,
    translateTitle: _i18n.translateTitle,
    onCountDownEnd: function onCountDownEnd() {
      this.getFinancesProductInfo();
    },
    onShowInfo: function onShowInfo() {
      window.open("https://top6688.zendesk.com/hc/zh-cn/articles/360019970998-%E6%B1%87%E4%BF%A1%E6%B1%A0");
    },
    onMessage: function onMessage(ico_url) {
      window.open(ico_url);
    },
    formatNumberRgx: function formatNumberRgx(num) {
      var parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    onOK: function onOK() {
      if (!this.userInfo) {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
        return;
      }

      this.$emit("onConfirm");
    },
    onTabClick: function onTabClick(item) {
      var _this2 = this;

      this.currTab = item.value;
      this.klineXList = [];
      this.klineYList = [];

      if (item.value == 1) {
        this.rateList.forEach(function (ele) {
          _this2.klineXList.push(_this2.timestampToDay(ele.date));

          _this2.klineYList.push(ele.rate);
        });
      }

      if (item.value == 2) {
        this.rateList30.forEach(function (ele) {
          _this2.klineXList.push(_this2.timestampToDay(ele.date));

          _this2.klineYList.push(ele.rate);
        });
      } else if (item.value == 3) {
        this.incRateList.forEach(function (ele) {
          _this2.klineXList.push(_this2.timestampToDay(ele.date));

          _this2.klineYList.push(ele.rate);
        });
        var maxValue = Math.max.apply(Math, (0, _toConsumableArray2.default)(this.klineYList));
        var minValue = Math.min.apply(Math, (0, _toConsumableArray2.default)(this.klineYList));
        var interval = (maxValue - minValue) / 2;
        this.mutiKlineOptionHistory.yAxis[0].min = minValue - interval / 2;
        this.mutiKlineOptionHistory.yAxis[0].max = maxValue + interval / 2;
        this.mutiKlineOptionHistory.yAxis[0].interval = interval;
        this.mutiKlineOptionHistory.yAxis[0].splitNumber = 3;
        this.mutiKlineOptionHistory.xAxis[0].data = this.klineXList;
        this.mutiKlineOptionHistory.series[0].data = this.klineYList;
      }

      this.mutiKlineOption.xAxis[0].data = this.klineXList;
      this.mutiKlineOption.series[0].data = this.klineYList;

      if (item.value == 3) {
        this.$nextTick(function () {
          _this2.$refs.mutiKlineOptionHistory.setOption(_this2.mutiKlineOptionHistory);
        });
      } else {
        this.$nextTick(function () {
          _this2.$refs.mutiKlineOption.setOption(_this2.mutiKlineOption);
        });
      }
    },
    onDialogClose: function onDialogClose() {
      this.$emit("onDialogClose");
    },
    getFinancesProductInfo: function getFinancesProductInfo() {
      var _this3 = this;

      var params = {
        product_id: this.productId
      };
      this.pageLoading = true;
      (0, _finance.apiGetProductInfo)(params).then(function (res) {
        if (res.status == 200) {
          _this3.productInfo = res.data.productInfo;

          _this3.$emit("onProductInfoChange", _this3.productInfo);

          _this3.xList = res.data.rateList;
          _this3.rateList = res.data.rateList;
          _this3.rateList30 = res.data.rateList30;
          _this3.incRateList = res.data.incRateList;
          _this3.klineXList = [];
          _this3.klineYList = [];

          _this3.rateList.forEach(function (ele) {
            _this3.klineXList.push(_this3.timestampToDay(ele.date));

            _this3.klineYList.push(ele.rate);
          });

          var now_time = (new Date().getTime() / 1000).toFixed();
          var tempRate = _this3.productInfo.total_amount / _this3.productInfo.amount * 100;
          _this3.rate = (0, _digital.ceilNumber)(tempRate, 2); // (
          //   (this.productInfo.total_amount / this.productInfo.amount) *
          //   100
          // ).toFixed(2);

          _this3.rate1 = (now_time - _this3.productInfo.start_time) / (_this3.productInfo.stop_time - _this3.productInfo.start_time);
          _this3.rate1 = _this3.rate1 > 1 ? 1 : _this3.rate1;
          _this3.rate2 = (now_time - _this3.productInfo.stop_time) / (_this3.productInfo.end_time - _this3.productInfo.stop_time);
          _this3.rate2 = _this3.rate2 > 1 ? 1 : _this3.rate2;

          if (_this3.productInfo.status == 3) {
            _this3.stepActive = 1;
          } else if (_this3.productInfo.status >= 4 && _this3.productInfo.status < 7) {
            _this3.stepActive = 2;
          } else if (_this3.productInfo.status == 7) {
            _this3.stepActive = 3;
          }

          if (_this3.productInfo.product_type != 2) {
            var now = Date.parse(new Date());

            if (_this3.productInfo.start_time != 0) {
              _this3.productInfo.remain_time = _this3.productInfo.start_time * 1000 - now;
            } else {
              _this3.productInfo.timeCount = 0;
            }
          }

          if (_this3.productInfo.product_type == 2) {
            _this3.currentKlineOption.xAxis[0].data = _this3.klineXList;
            _this3.currentKlineOption.series[0].data = _this3.klineYList;
            _this3.mutiKlineOption.xAxis[0].data = _this3.klineXList;
            _this3.mutiKlineOption.series[0].data = _this3.klineYList;
            _this3.showName = (0, _formatDate.timestampToDay)(_this3.xList[_this3.xList.length - 1].date);
            _this3.showData = _this3.productInfo.annual_rate.toFixed(2);
          } else if (_this3.productInfo.product_type == 3) {
            _this3.mutiKlineOption.xAxis[0].data = _this3.klineXList;
            _this3.mutiKlineOption.series[0].data = _this3.klineYList;
          }

          _this3.options.series[0].data[0].value = _this3.productInfo.user_profit;
          _this3.options.series[0].data[1].value = _this3.productInfo.trader_profit;
        } else {
          (0, _message.showMessage)({
            message: res.msg,
            type: "error"
          });
        }

        _this3.pageLoading = false;

        _this3.$nextTick(function () {
          if (_this3.productInfo.product_type == 2) {
            _this3.$refs.currentKlineOption.setOption(_this3.currentKlineOption);

            _this3.$refs.mutiKlineOption.setOption(_this3.mutiKlineOption);
          } else if (_this3.productInfo.product_type == 3) {
            _this3.$refs.mutiKlineOption.setOption(_this3.mutiKlineOption);

            _this3.$refs.dataEchart.setOption(_this3.options);
          }
        });
      });
    }
  }
};
exports.default = _default;